import React, {useState, useEffect, createContext, useContext, useRef, useLayoutEffect} from "react";
import {TestCard} from "../../components/global/VideoCard";
import {TestContext} from "../../context/test_context";
import {
    Avatar,
    Badge,
    Box,
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardHeader,
    CircularProgress,
    Grid,
    Icon,
    IconButton,
    Input,
    Pagination,
    Stack,
    TextField,
    Typography,
    debounce,
    alpha,
    Button, useTheme,
} from "@mui/material";
import "./styles.css";
import useAuth from "../../hooks/auth_hook";
import {useNavigate} from "react-router-dom";
import LoadBox from "../../components/global/LoadBox";
import moment from "moment";
import {ArrowBack, Close, Refresh} from "@mui/icons-material";
import TestsControlButtons from "../../components/tests/TestsControlButtons";
import {tokens} from "../../theme";

export const TestPageContext = createContext<any>(null);

export default function Tests(): any {
    const [reload, setReload] = useState(false)
    return (
        <TestPageContext.Provider value={{reload, setReload}}>
            <Box
                sx={{
                    width: "100%",
                    display: {xs: "block", md: "flex"},
                    justifyContent: "center",
                    marginX: 5,
                    flexDirection: "row",
                    pt: 2,
                    maxheight: "100%",
                }}
            >
                <TestList finished={false} active={true} title={"Ongoing Tests"}/>

                <TestList finished={false} active={false} title={"Paused Tests"}/>

            </Box>
        </TestPageContext.Provider>
    );
}

export type TestList = {
    tests: any;
    testgroup: any | null;
    testgroup_index: any;
};

export function TestGroupBox({tests, testgroup, testgroup_index}: TestList): any {
    const navigate = useNavigate();
    const {loading, pauseLoading, getTestGroup} = React.useContext(TestContext);

    const calculateCurrentTest = (tests: any) => {
        if (tests.filter((test: any) => test.tested).length === tests.length) {
            return tests[tests.length - 1];
        }
        return tests.find((test: any) => test.active) || tests[0];
    };

    const currentTest = calculateCurrentTest(tests);
    const {user} = useAuth();

    var test_status: any = "";

    if (currentTest && tests) {
        if (currentTest.order + 1 < tests.length) {
            test_status = `On test ${currentTest.order + 1} out of ${tests.length}`;
        } else if (currentTest.order + 1 === tests.length) {
            test_status = `Test Complete`;
        }
    }

    const firstRender = useRef(true);

    useEffect(() => {
        setTimeout(() => {
            firstRender.current = false;
        }, 0);
    }, []);

    console.log(testgroup);
    return (
        currentTest && testgroup && (

            <Box
                sx={{width: "100%", height: "100%", padding: 2, overflowY: "visible"}}
                id={currentTest.id}

            >

                <Badge
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "left",
                    }}
                    color={
                        testgroup.active
                            ? "success"
                            : testgroup.finished
                                ? "success"
                                : "warning"
                    }
                    className={testgroup.active ? 'success_badge_running' : ''}
                    badgeContent={<span></span>}
                    sx={{width: "100%", height: "100%"}}
                >

                    <Card
                        sx={{
                            width: "100%",
                            height: "100%",
                            boxShadow: `0px 0px 5px 0px ${alpha("#000000", 0.2)}`,
                        }}

                    >
                        <LoadBox loading={(pauseLoading || loading) && firstRender}>
                            <CardActionArea
                                onClick={() => {
                                    if (currentTest && currentTest.testgroup) {
                                        navigate(`/tests/${currentTest.testgroup}`);
                                    }
                                }}
                            >
                                <Box sx={{backgroundColor: "black", borderRadius: "16px"}}>
                                    <img
                                        src={currentTest && currentTest.imgLink ? currentTest.imgLink : ""}
                                        style={{
                                            width: "100%",
                                            objectFit: "contain",
                                            borderRadius: "16px",
                                            minHeight: "90px",
                                            minWidth: "160px",
                                            maxHeight: "300px",
                                        }}
                                        alt="Thumbnail for Youtube Video titled: "
                                    />
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        boxShadow: `0px 2px 2px 0px ${alpha("#000000", 0.1)}`,
                                    }}
                                >
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                src={user?.user_metadata?.avatar_url}
                                                aria-label="recipe"
                                                sx={{height: "30px", width: "30px"}}
                                            ></Avatar>
                                        }
                                        title={currentTest && currentTest.title ? currentTest.title : ""}
                                        subheader={
                                            <>
                      <span>
                        {test_status}
                          <br></br>
                          {currentTest && currentTest.time_to_test ? moment(currentTest.time_to_test).fromNow() : ""}
                      </span>
                                            </>
                                        }
                                    />
                                </Box>
                            </CardActionArea>

                            <Box
                                // className={testgroup.active
                                //     ? "success_badge_running"
                                //     : testgroup.finished
                                //         ? "bg-success"
                                //         : "bg-warning"}
                                id={"buttons"}
                                sx={{
                                    display: "flex",
                                    width: "100%",
                                    justifyContent: "center",
                                    py: 1,
                                }}
                            >
                                <TestsControlButtons testgroup={testgroup} testgroup_index={testgroup_index}/>
                            </Box>
                        </LoadBox>
                    </Card>

                </Badge>

            </Box>

        )
    );
}

export const TestListContext = createContext<any>(null);

export function TestList({finished, active, title}: any): any {
    const {loading, getTestGroups, results_per_page} =
        React.useContext(TestContext);

    const [testgroups, setTestGroups] = useState<any>([]);
    const [search, setSearch] = useState<string>("");
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [count, setCount] = useState<number>(0);
    const totalPages = Math.ceil(count / results_per_page);
    const [renders, setRenders] = useState(0);
    const {reload, setReload} = useContext(TestPageContext);
    // console.log({totalPages, count, results_per_page});

    const searchTestGroups = async (search: string, currentPage: number) => {
        getTestGroups(search, currentPage, {finished, active}).then(
            ({testgroups, count}: any) => {
                // console.log({testgroups, count});
                setTestGroups(testgroups);
                setCount(count);
            },
        );
    };


    const debouncedSearch = debounce(searchTestGroups, 500);
    useEffect(() => {
        debouncedSearch(search, currentPage);
    }, [search, currentPage]);

    const filteredTestGroups = React.useMemo(
        () =>
            testgroups.filter((testgroup: any) => {
                return testgroup && testgroup.tests && testgroup.tests.some((test: any) =>
                    test && test.title && test.title.toLowerCase().includes(search.toLowerCase()),
                );
            }),
        [search, testgroups],
    );

    useEffect(() => {
        searchTestGroups(search, currentPage)
    }, [reload]);

    const firstRender = useRef(true);

    useEffect(() => {
        setTimeout(() => {
            firstRender.current = false;
        }, 0);
    }, []);


    return (
        <TestListContext.Provider value={{testgroups, setTestGroups}}>
            <Card
                sx={{
                    width: "100%",
                    height: "100%",
                    overflowY: "visible",
                    boxShadow: "none",
                    mb: 2,
                }}
            >
                <Card
                    sx={{
                        margin: 1,
                        padding: 1,
                        boxShadow: `0px 0px 5px 0px ${alpha("#000000", 0.2)}`,
                    }}
                >
                    <Box sx={{fontSize: "h3.fontSize"}}>{title}</Box>
                    <CardActions sx={{justifyContent: "space-between"}}>
                        <TextField
                            value={search}
                            label="Search..."
                            onChange={(e) => {
                                setSearch(e.target.value);
                            }}
                        ></TextField>
                        <IconButton
                            onClick={() => {
                                searchTestGroups(search, currentPage);
                            }}
                        >
                            <Icon>
                                <Refresh/>
                            </Icon>
                        </IconButton>
                    </CardActions>
                    <LoadBox loading={firstRender.current}>
                        <CardContent
                            sx={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "flex-start",
                                flexWrap: "wrap",
                            }}
                        >
                            {filteredTestGroups.map((testgroup: any, ind: number) => {
                                return (
                                    <TestGroupBox
                                        tests={testgroup.tests}
                                        key={ind}
                                        testgroup={testgroup}
                                        testgroup_index={ind}
                                    />
                                );
                            })}
                            {filteredTestGroups.length == 0 && (
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%"
                                    width="100%"
                                    padding={8}
                                >
                                    <Typography variant="subtitle1">{"No tests..."}</Typography>
                                </Box>
                            )}
                        </CardContent>
                        <Pagination
                            sx={{marginBottom: 4, marginTop: "auto"}}
                            count={totalPages}
                            page={currentPage}
                            onChange={(e, page) => {
                                setCurrentPage(page);
                            }}
                        />
                    </LoadBox>
                </Card>{" "}
            </Card>
        </TestListContext.Provider>
    );
}
